import { CountryViewModel } from '@bhtp-client-web/component';

export class Country extends CountryViewModel {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/country.model.ts